import type { FindFn } from "@shared/models/analytics/base"
import type { PatchModel } from "@shared/models/patch"
import Patch from "@shared/models/patch-updater"
import type { PreparedAction } from "../../action-doc-builder"
import { partial } from "lodash-es"
import type { Narrative } from "../create-narrative"
import defaultPlanbookActivity from "./default-planbook-activity"
import defaultPlanbookContext from "./default-planbook-context"
import defaultPlanbookModels from "./default-planbook-models"

interface Payload {
  planbookId: string
  integrationName: string
  prop: string
  value: any
}

export default function prepareUpdatePlanbookIntegration(payload: Payload): PreparedAction {
  return {
    name: "PLANBOOK_INTEGRATION_UPDATE",
    payload: payload,
    patches: patches(payload),
    undoPatches: null,
    narrative: partial(narrative, payload),
  }
}

const patches = function (payload: Payload): Array<PatchModel> {
  let patch = Patch.create("planbook", payload.planbookId).set(
    `attributes.integrations.${payload.integrationName}.${payload.prop}`,
    payload.value
  ).patch
  return [patch]
}
const undoPatches = null

const narrative = function (payload: Payload, findFn: FindFn, userId: string): Narrative | null {
  let models = defaultPlanbookModels(payload, findFn, userId, payload.planbookId)

  return {
    title: `Updated GC Integration time zone to ${payload.value}`,
    titleForAnalytics: "Planbook - Integrations - Update Integration",
    description: `Updated ${payload.prop} in GC integration`,
    context: defaultPlanbookContext(payload, models),
    activity: defaultPlanbookActivity(payload, models),
  }
}
